import React from "react";
import TopSellingHotel from "./TopSellingHotel";
import TopCustomer from "./TopCustomer";
import TopTourBooking from "./TopTourBooking";

const TopStats = ({ TableData }) => {
  return (
    <div className="grid grid-cols-3 gap-3">
      <TopSellingHotel TableData={TableData} />
      <TopCustomer TableData={TableData} />
      <TopTourBooking TableData={TableData} />
    </div>
  );
};

export default TopStats;
